import React, { FC } from 'react';

import Icon from '../Icon';
import getClassNames from '../../utils/getClassNames';

import styles from './Pagination.module.scss';

type PaginationProps = {
  variant: 'next' | 'previous';
};

const PaginationArrow: FC<PaginationProps> = ({ variant }) => (
  <Icon
    id="search/rounded-prev-button"
    className={getClassNames(styles, 'icon', variant)}
  />
);

export default PaginationArrow;
